// @flow
import type { Item, ItemFetcher } from '../item';

const filterItems = (items: Array<Item>, searchTerm: string): Array<Item> => {
  return items.filter((item) =>
    item.label.toLowerCase().startsWith(searchTerm.toLowerCase())
  );
};

/*
 Convert a list of options into a function that filters and returns a resolved promise.
 This allows us to always treat options as an async filtering function.
 */
const createAsyncFilter = (items: Array<Item>): ItemFetcher => {
  return (searchTerm: string) => {
    const promise = Promise.resolve({ items: filterItems(items, searchTerm) });
    // $FlowFixMe
    promise.preventLoadOnMount = false;
    return promise;
  };
};

export default createAsyncFilter;
